import * as React from 'react';
import type { SVGProps } from 'react';
const SvgCall = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="#A5A5AA"
      d="m20.52 15.476-2.373-2.372c-.847-.847-2.288-.508-2.626.593-.255.763-1.102 1.186-1.865 1.017-1.694-.424-3.982-2.627-4.405-4.406-.255-.763.254-1.61 1.016-1.864 1.102-.34 1.44-1.78.593-2.627L8.488 3.445c-.678-.593-1.695-.593-2.288 0l-1.61 1.61c-1.61 1.694.17 6.185 4.152 10.167s8.473 5.846 10.168 4.152l1.61-1.61c.593-.678.593-1.695 0-2.288Z"
    />
  </svg>
);
export default SvgCall;
